import * as types from './types';

const mutations = {
  [types.SET_GLOBAL_MESSAGE]: (state, payload) => {
    state.globalMessage = payload;
  },

  [types.RESET_GLOBAL_MESSAGE]: (state) => {
    state.globalMessage = {
      type: '',
      message: '',
    };
  },
  [types.RESET_ALL_STATE]: () => {},
  [types.SET_CURRENCY_MAP]: (state, payload) => {
    state.currencyMap = payload;
  },

};

export default mutations;
